import React from 'react';
const MapComponent = () => {

  return (
    <>
      <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d34462.01181697244!2d-82.76922610714807!3d27.984216307282107!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s2266%20gulf%20to%20bay%20boulevard%20lt%20345%20clearwater%20florida%20zip%2033765!5e0!3m2!1sen!2smx!4v1771986000558!5m2!1sen!2smx" 
      title="SETI Remodeling" 
      width="100%" 
      height="400"  
      allowfullscreen="" 
      loading="lazy" 
      referrerpolicy="no-referrer-when-downgrade"></iframe>
    </>
  );
};

export default MapComponent;